(function () {
    function initProjectSingleSliders() {
        if (typeof window.Swiper !== 'function') return;

        document.querySelectorAll('[data-project-gallery]').forEach(function (slider) {
            if (slider.swiper) return;

            new window.Swiper(slider, {
                slidesPerView: 1,
                spaceBetween: 6,
                speed: 550,
                watchOverflow: true,
                keyboard: {
                    enabled: true
                },
                a11y: {
                    enabled: true
                },
                pagination: {
                    el: slider.querySelector('.project-single__gallery-pagination'),
                    clickable: true
                },
                navigation: {
                    prevEl: slider.querySelector('.project-single__gallery-arrow--prev'),
                    nextEl: slider.querySelector('.project-single__gallery-arrow--next')
                }
            });
        });

        document.querySelectorAll('[data-project-related-slider]').forEach(function (slider) {
            if (slider.swiper) return;

            const section = slider.closest('.project-single__related');

            new window.Swiper(slider, {
                slidesPerView: 1,
                spaceBetween: 6,
                speed: 550,
                watchOverflow: true,
                keyboard: {
                    enabled: true
                },
                a11y: {
                    enabled: true
                },
                pagination: {
                    el: section ? section.querySelector('.project-single__related-pagination') : null,
                    clickable: true
                },
                navigation: {
                    prevEl: section ? section.querySelector('.project-single__related-arrow--prev') : null,
                    nextEl: section ? section.querySelector('.project-single__related-arrow--next') : null
                },
                breakpoints: {
                    769: {
                        slidesPerView: 2
                    }
                }
            });
        });

    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initProjectSingleSliders);
    } else {
        initProjectSingleSliders();
    }
}());
